module.exports = __webpack_public_path__ + "img/16.b8e49b00.png";